<template>
  <page>
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-autocomplete
                  :label="labels.inoutwards"
                  :items="inOutList"
                  v-model="form.inoutwards"
                  item-text="value"
                  item-value="code"
                  data-vv-name="inoutwards"
                  :data-vv-as="labels.inoutwards"
                  :error-messages="errors.collect('inoutwards')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.acctPeriodFrom"
                  :label="labels.acctPeriodFrom"
                  v-validate="'required'"
                  :data-vv-as="labels.acctPeriodFrom"
                  data-vv-name="acctPeriodFrom"
                  :error-messages="errors.collect('acctPeriodFrom')"
                  format="yyyy-MM-dd"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.acctPeriodTo"
                  :label="labels.acctPeriodTo"
                  v-validate="'required'"
                  :data-vv-as="labels.acctPeriodTo"
                  data-vv-name="acctPeriodTo"
                  :error-messages="errors.collect('acctPeriodTo')"
                  :min="this.form.acctPeriodFrom"
                  format="yyyy-MM-dd"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-autocomplete
                  :label="labels.acctMonthFrom"
                  :items="monthList"
                  v-model="form.acctMonthFrom"
                  item-text="value"
                  item-value="code"
                  data-vv-name="acctMonthFrom"
                  :data-vv-as="labels.acctMonthFrom"
                  :error-messages="errors.collect('acctMonthFrom')"
                  @change="updateMonth($event)"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  :label="labels.acctMonthTo"
                  :items="monthList"
                  v-model="form.acctMonthTo"
                  item-text="value"
                  item-value="code"
                  data-vv-name="acctMonthTo"
                  :data-vv-as="labels.acctMonthTo"
                  :error-messages="errors.collect('acctMonthTo')"
                  v-validate="toMonthValidation"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.acctYearFrom"
                  :label="labels.acctYearFrom"
                  :error-messages="errors.collect('acctYearFrom')"
                  data-vv-name="acctYearFrom"
                  :data-vv-as="labels.acctYearFrom"
                  type="number"
                  @change="updateYear($event)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.acctYearTo"
                  :label="labels.acctYearTo"
                  :error-messages="errors.collect('acctYearTo')"
                  data-vv-name="acctYearTo"
                  :data-vv-as="labels.acctYearTo"
                  type="number"
                  v-validate="toYearValidation"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="form.treatyStatementType"
                  :label="labels.treatyStatementType"
                  :error-messages="errors.collect('treatyStatementType')"
                  data-vv-name="treatyStatementType"
                  :data-vv-as="labels.treatyStatementType"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('stmtType')"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('stmtType')"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="form.treatyStatementRef"
                  :label="labels.treatyStatementRef"
                  :error-messages="errors.collect('treatyStatementRef')"
                  data-vv-name="treatyStatementRef"
                  :data-vv-as="labels.treatyStatementRef"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('stmtRef')"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('stmtRef')"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.treatyRefFrom"
                  :label="labels.treatyRefFrom"
                  :error-messages="errors.collect('treatyRefFrom')"
                  data-vv-name="treatyRefFrom"
                  :data-vv-as="labels.treatyRefFrom"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('ttyRefFrom')"
                  readonly
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('ttyRefFrom')"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.treatyRefTo"
                  :label="labels.treatyRefTo"
                  :error-messages="errors.collect('treatyRefTo')"
                  data-vv-name="treatyRefTo"
                  :data-vv-as="labels.treatyRefTo"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('ttyRefTo')"
                  readonly
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('ttyRefTo')"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="form.statementLines"
                  :label="labels.statementLines"
                  :error-messages="errors.collect('statementLines')"
                  data-vv-name="statementLines"
                  :data-vv-as="labels.statementLines"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('stmtLine')"
                  readonly
                  v-validate="'required'"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('stmtLine')"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-autocomplete
                  :label="labels.rptType"
                  :items="rptTypeList"
                  v-model="form.rptType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rptType"
                  :data-vv-as="labels.rptType"
                  :error-messages="errors.collect('rptType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-autocomplete
                  :label="labels.sortOrder"
                  :items="sortOrderList"
                  v-model="form.sortOrder"
                  item-text="value"
                  item-value="code"
                  data-vv-name="sortOrder"
                  :data-vv-as="labels.sortOrder"
                  :error-messages="errors.collect('sortOrder')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox color="primary" :label="labels.release" v-model="form.release"></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-checkbox color="primary" :label="labels.suppressZero" v-model="form.suppressZero"></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-checkbox color="primary" :label="labels.rptParam" v-model="form.rptParam"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 class="pt-3">
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
        <v-dialog v-model="HelpList" width="900px" persistent>
          <help-list
            :fromDate="this.convertDate(form.acctPeriodFrom)"
            :toDate="this.convertDate(form.acctPeriodTo)"
            :inoutwards="form.inoutwards"
            :boolRefresh="HelpList"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></help-list>
        </v-dialog>
        <v-dialog v-model="TtyRefHelpList" width="900px" persistent>
          <tty-ref-help-list
            :fromDate="this.convertDate(form.acctPeriodFrom)"
            :toDate="this.convertDate(form.acctPeriodTo)"
            :inoutwards="form.inoutwards"
            :boolRefresh="TtyRefHelpList"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></tty-ref-help-list>
        </v-dialog>
        <v-dialog v-model="StmtLineHelpList" width="900px" persistent>
          <stmt-line-help-list
            :inoutwards="form.inoutwards"
            :boolRefresh="StmtLineHelpList"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></stmt-line-help-list>
        </v-dialog>
        <v-dialog v-model="StmtTypeHelpList" width="900px" persistent>
          <stmt-type-help-list
            :inoutwards="form.inoutwards"
            @close="doClose"
            @doAssign="doAssign($event)"
          ></stmt-type-help-list>
        </v-dialog>
      </v-card-text>
    </v-card>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import HelpList from './StatementRefHelpList.vue'
import TtyRefHelpList from './TreatyRefHelpList.vue'
import StmtLineHelpList from './StatementLineHelpList.vue'
import StmtTypeHelpList from './StatementTypeHelpList.vue'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      labels: {
        inoutwards: 'Inwards / Outwards',
        acctPeriodFrom: 'Accounting Period End Date From',
        acctPeriodTo: 'Accounting Period End Date To',
        acctMonthFrom: 'Account Month From',
        acctMonthTo: 'Account Month To',
        acctYearFrom: 'Account Year From',
        acctYearTo: 'Account Year To',
        treatyStatementType: 'Treaty Statement Type',
        treatyStatementRef: 'Treaty Statement Ref',
        treatyRefFrom: 'Treaty Ref From',
        treatyRefTo: 'Treaty Ref To',
        statementLines: 'Statement Lines',
        rptType: 'Report Type',
        sortOrder: 'Sorting Order',
        export: 'Export To ',
        release: 'Released',
        suppressZero: 'Suppress Zero Value',
        rptParam: 'Print report runtime parameters'
      },
      form: {
        inoutwards: 'O',
        acctPeriodFrom: null,
        acctPeriodTo: new Date(),
        acctMonthFrom: '00',
        acctMonthTo: '00',
        acctYearFrom: 0,
        acctYearTo: 0,
        treatyStatementType: 'All',
        treatyStatementRef: 'All',
        treatyRefFrom: null,
        treatyRefTo: null,
        statementLines: 'All',
        rptType: 'DET',
        sortOrder: 'ri',
        format: 'PDF',
        release: false,
        suppressZero: false,
        rptParam: false
      },
      inOutList: [
        { code: 'IN', value: 'Inwards' },
        { code: 'O', value: 'Outwards' }
      ],
      monthList: [
        { code: '00', value: '00' },
        { code: '01', value: '01' },
        { code: '02', value: '02' },
        { code: '03', value: '03' },
        { code: '04', value: '04' },
        { code: '05', value: '05' },
        { code: '06', value: '06' },
        { code: '07', value: '07' },
        { code: '08', value: '08' },
        { code: '09', value: '09' },
        { code: '10', value: '10' },
        { code: '11', value: '11' },
        { code: '12', value: '12' }
      ],
      supportedFormat: [],
      rptTypeList: [
        { code: 'DET', value: 'Detail' },
        { code: 'ALL', value: 'Detail and Summary' }
      ],
      sortOrderList: [
        { code: 'ri', value: 'Reinsurer' },
        { code: 'tty', value: 'Treaty' }
      ],
      HelpList: false,
      TtyRefHelpList: false,
      StmtLineHelpList: false,
      StmtTypeHelpList: false,
      defAll: true,
      submitting: false,
      ttyRef: ''
    }
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    toDateValidation() {
      if (this.form.option1 === true && this.form.interFrom !== '' && this.form.interFrom !== null) {
        return 'required|valToNo:' + this.form.interFrom
      } else {
        return ''
      }
    },
    toMonthValidation() {
      if (this.form.acctMonthFrom) {
        return 'required|valMinAcctMth:' + this.form.acctMonthFrom
      } else {
        return ''
      }
    },
    toYearValidation() {
      if (this.form.acctYearFrom) {
        return 'required|valMinAcctYr:' + this.form.acctYearFrom
      } else {
        return ''
      }
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.ttyReports.init !== 1) {
          await this.$store.dispatch('ttyReportsInit')
        }
        const apiURI = this.$store.state.reports.ttyReports.menu.ttyStmtAuditListB
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      switch (fieldName) {
        case 'stmtRef':
          this.HelpList = true
          break
        case 'ttyRefFrom':
          this.ttyRef = 'From'
          this.TtyRefHelpList = true
          break
        case 'ttyRefTo':
          this.ttyRef = 'To'
          this.TtyRefHelpList = true
          break
        case 'stmtLine':
          this.StmtLineHelpList = true
          break
        case 'stmtType':
          this.StmtTypeHelpList = true
          break
        default:
          this.$toast.error('Field Name Not Found!')
      }
    },
    async doAssign(Obj) {
      if (Obj.finalSelectedItems) {
        if (this.HelpList) {
          this.form.treatyStatementRef = []
          this.form.treatyStatementRef = Obj.finalSelectedItems.toString()
          // Add condition to determine which helplist is it from FROM/TO
        } else if (this.TtyRefHelpList && this.ttyRef === 'From') {
          this.form.treatyRefFrom = []
          this.form.treatyRefTo = []
          this.form.treatyRefFrom = Obj.finalSelectedItems.toString()
          this.form.treatyRefTo = Obj.finalSelectedItems.toString()
        } else if (this.TtyRefHelpList && this.ttyRef === 'To') {
          this.form.treatyRefTo = []
          this.form.treatyRefTo = Obj.finalSelectedItems.toString()
        } else if (this.StmtLineHelpList) {
          this.form.statementLines = []
          this.form.statementLines = Obj.finalSelectedItems.toString()
        } else if (this.StmtTypeHelpList) {
          this.form.treatyStatementType = []
          this.form.treatyStatementType = Obj.finalSelectedItems.toString()
        }
      } else {
        this.$toast.error('Help List Assignment Missing')
      }
    },
    doClose() {
      this.HelpList = false
      this.TtyRefHelpList = false
      this.StmtLineHelpList = false
      this.StmtTypeHelpList = false
    },
    convertDate(dateString) {
      const date = new Date(dateString)
      const mnth = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return [date.getFullYear(), mnth, day].join('-')
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      try {
        this.loading = true
        await this.$http.post(apiURI, this.form)
        this.loading = false
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
        this.loading = false
      }
    },
    updateMonth(month) {
      this.form.acctMonthFrom = month
      this.form.acctMonthTo = month
    },
    updateYear(year) {
      this.form.acctYearFrom = year
      this.form.acctYearTo = year
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('minYear', {
      getMessage(field, args) {
        return 'You are selecting a date in the last century.'
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const lessThan2000 = new Date(today)
          lessThan2000.setFullYear(2000)
          const startDate = removeTime(value)
          return startDate.getFullYear() >= lessThan2000.getFullYear()
        } else return true
      }
    })

    this.$validator.extend('valMinAcctMth', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Mth'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })

    this.$validator.extend('valMinAcctYr', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Year'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  components: {
    HelpList,
    TtyRefHelpList,
    StmtLineHelpList,
    StmtTypeHelpList
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
